import React from "react";

const Footer = () => (
    <div className="row" id="Footer" style={{ height: 20 }} />
);

export default Footer;
